// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Zmm1iF5W28pAOKVsX5zE {\n\tdisplay: grid;\n\tgrid-gap: 16px;\n\tgap: 16px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/StakePage/StakePage.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,cAAS;CAAT,SAAS;AACV","sourcesContent":[".inner {\n\tdisplay: grid;\n\tgap: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inner": "Zmm1iF5W28pAOKVsX5zE"
};
export default ___CSS_LOADER_EXPORT___;
